import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isCheckOpenModal: false,
  dataExam: [],
  valueTypeQuestion: [],
  dataExamDetail: undefined,
  selectedYear: undefined,
  questionType: undefined,
  isCheckFilter: false,
};

const examSlice = createSlice({
  name: "exam",
  initialState,
  reducers: {
    setIsCheckOpenModal: (state, action) => {
      state.isCheckOpenModal = action.payload;
    },
    setDataExam: (state, action) => {
      state.dataExam = action.payload;
    },
    setValueTypeQuestion: (state, action) => {
      state.valueTypeQuestion = action.payload;
    },
    setDataExamDetail: (state, action) => {
      state.dataExamDetail = action.payload;
    },
    resetDataExam: (state, action) => {
      state.isCheckOpenModal = false;
      state.dataExamDetail = undefined;
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload;
    },
    setQuestionType: (state, action) => {
      state.questionType = action.payload;
    },
    setIsCheckFilter: (state, action) => {
      state.isCheckFilter = !state.isCheckFilter;
      state.selectedYear = undefined;
      state.questionType = undefined;
    },
  },
});

export const {
  setIsCheckOpenModal,
  setDataExam,
  setValueTypeQuestion,
  setDataExamDetail,
  resetDataExam,
  setSelectedYear,
  setQuestionType,
  setIsCheckFilter,
} = examSlice.actions;
export default examSlice.reducer;
